import React, { useMemo, useState } from 'react'
import { useMutation } from 'react-query'
import { submitFeedback } from '../../api/feedback'
import StarRatingField from './star-rating-field'

const REQUIRED_FIELDS = []

const defaultValues = {
  q1: '',
  q2: '',
  q3: '',
  q4: '',
  q5: '',
  q6: '',
  q7: '',
  q8: '',
  q9: '',
  q10: '',
}

const AnnualFeedbackForm = ({ token, customerFirstName, onSuccess = () => {} }) => {
  const [values, setValues] = useState(defaultValues)
  const [error, setError] = useState(null)

  const mutation = useMutation((payload) => submitFeedback(payload), {
    onError: (err) => {
      setError(err.message || 'We could not submit your feedback. Please try again.')
    },
    onSuccess: () => {
      setError(null)
      onSuccess()
    },
  })

  const greetingName = useMemo(() => customerFirstName || 'there', [customerFirstName])

  const handleRatingChange = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }))
  }

  const handleTextChange = (event) => {
    const { name, value } = event.target
    setValues((prev) => ({ ...prev, [name]: value }))
  }

  const validate = () => {
    const missing = REQUIRED_FIELDS.filter((field) => !values[field])

    if (missing.length > 0) {
      setError('Please answer all required questions before submitting your feedback.')
      return false
    }

    return true
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setError(null)

    if (!validate()) {
      return
    }

    mutation.mutate({
      token,
      ...values,
    })
  }

  return (
    <form className="c-feedback-form" onSubmit={handleSubmit}>
      <div className="c-feedback-modal__intro">
        <h2 className="c-content-media__title c-feedback-intro__title">Hi {greetingName},</h2>
        <div className="c-content-media__content c-feedback-intro__content">
          Thank you so much for taking a moment to share your feedback.
        </div>
      </div>

      <h3 className="c-feedback-form__heading">Core questions</h3>

      <StarRatingField
        name="q1"
        label="Overall, how do you rate our performance?"
        value={values.q1}
        onChange={(val) => handleRatingChange('q1', val)}
      />
      <StarRatingField
        name="q2"
        label="How likely would you be to recommend us to others?"
        value={values.q2}
        onChange={(val) => handleRatingChange('q2', val)}
      />

      <div className="c-feedback-field">
        <label className="c-form__label" htmlFor="q3">
          Thinking about these ratings, what influenced your view?
        </label>
        <textarea
          id="q3"
          name="q3"
          rows="4"
          className="c-form__textarea"
          value={values.q3}
          onChange={handleTextChange}
        />
      </div>


      <div className="c-feedback-form__section-header">
        <h3 className="c-feedback-form__heading">Additional questions (optional)</h3>
      </div>

      <StarRatingField
        name="q4"
        label="Quality of work we deliver"
        value={values.q4}
        onChange={(val) => handleRatingChange('q4', val)}
        allowNA
      />
      <StarRatingField
        name="q5"
        label="Ability to meet your brief and desired outcomes"
        value={values.q5}
        onChange={(val) => handleRatingChange('q5', val)}
        allowNA
      />
      <StarRatingField
        name="q6"
        label="Quality of client service you receive"
        value={values.q6}
        onChange={(val) => handleRatingChange('q6', val)}
        allowNA
      />
      <StarRatingField
        name="q7"
        label="Effectiveness of our communication"
        value={values.q7}
        onChange={(val) => handleRatingChange('q7', val)}
        allowNA
      />
      <StarRatingField
        name="q8"
        label="Overall value for money you receive"
        value={values.q8}
        onChange={(val) => handleRatingChange('q8', val)}
        allowNA
      />
      <StarRatingField
        name="q9"
        label="Ability to address your future needs"
        value={values.q9}
        onChange={(val) => handleRatingChange('q9', val)}
        allowNA
      />

      <div className="c-feedback-field">
        <label className="c-form__label" htmlFor="q10">
          Please share any comments that help us learn from your ratings.
        </label>
        <textarea
          id="q10"
          name="q10"
          rows="4"
          className="c-form__textarea"
          value={values.q10}
          onChange={handleTextChange}
        />
      </div>

      <div className="c-feedback-form__actions">
        {error ? (
          <div className="f-messages">
            <div className="f-messages__alert f-messages__alert--error">
              <p>{error}</p>
            </div>
          </div>
        ) : null}

        <button type="submit" className="c-btn c-btn--large c-btn--primary" disabled={mutation.isLoading}>
          {mutation.isLoading ? 'Submitting...' : 'Send feedback'}
        </button>
      </div>
    </form>
  )
}

export default AnnualFeedbackForm

